import { CommentType } from "lib/domain/comments/CommentAnalytics";
import { SentimentRating } from "types/Result";

export default {
	globalAttributeName: "Gesamte Organisation",
	segment: "Segment",
	percent: "Prozent",
	btnChangeLanguage: "Sprache ändern",
	copied: "In die Zwischenablage kopiert",
	languages: {
		german: "Deutsch",
		de: "Deutsch",
		english: "Englisch",
		en: "Englisch",
		russian: "Russisch",
		ru: "Russisch",
		pl: "Polnisch",
		polish: "Polnisch",
		tr: "Türkisch",
		ro: "Rumänisch",
		cs: "Tschechisch",
		zh: "Chinesisch (China)",
		es: "Spanisch",
		da: "Dänisch",
		fr: "Französisch",
		ja: "Japanisch",
		fi: "Finnisch",
		hu: "Ungarisch",
		sv: "Schwedisch",
		lt: "Litauisch",
		bg: "Bulgarisch",
		uk: "Ukrainisch",
		it: "Italienisch",
		bs: "Bosnisch",
		sl: "Slowenisch",
		hr: "Kroatisch",
		ar: "Arabisch",
		el: "Griechisch",
		pt: "Portugiesisch",
		sq: "Albanisch",
		ms: "Malaysisch",
		fa: "Persisch",
		ku: "Kurdisch",
		sr: "Serbisch",
	},
	saveAsImage: "Als Bild speichern",
	sentiment: {
		[SentimentRating.neutral]: "Neutral",
		[SentimentRating.mixed]: "Gemischt",
		[SentimentRating.negative]: "Negativ",
		[SentimentRating.veryNegative]: "Sehr negativ",
		[SentimentRating.positive]: "Positiv",
		[SentimentRating.veryPositive]: "Sehr positiv",
	},
	commentType: {
		[CommentType.idea]: "Vorschlag",
		[CommentType.praise]: "Lob",
		[CommentType.critic]: "Kritik",
		[CommentType.sensitive]: "Sensitiv",
		[CommentType.other]: "Sonstiges",
	},
	threshold: "Richtwert",
	roles: {
		admin: "Administrator",
		user: "Benutzer",
		"user-editor": "Benutzer-Editor",
		"peer-feedback-user": "Peer-Feedback-Benutzer",
		"read-all-reports": "Alle Berichte freigeben",
		"share-reports": "Berichte extern teilen",
		"access-all-data": "Zugriff auf alle Daten",
	},
	roleDescriptions: {
		admin: "Vollzugriff auf Kultify inklusive aller Verwaltungsfunktionen",
		user: "Zugriff auf den Userbereich von Kultify",
		"user-editor":
			"Kann die Benutzer der Plattform verwalten und die erstellen Attribute einsehen",
		"peer-feedback-user": "Kann eigene Peer-Feedbacks erstellen und ansehen.",
		"read-all-reports":
			"Kann alle Berichte einsehen. Ergebnisse müssen separat freigegeben werden.",
		"access-all-data":
			"Kann auf alle Daten in den für den Nutzer zugreifbaren Berichten zugreifen.",
		"share-reports": "Kann Berichte extern teilen.",
	},
	groupBy: {
		round: "Runde",
		week: "Woche",
		day: "Tag",
		month: "Monat",
		quarter: "Quartal",
		year: "Jahr",
	},
	roundDate: {
		round: "{{date, D}}",
		today: "Heute",
		day: "{{date, D}}",
		week: "{{date, MM'.'y 'KW'W+useTZ}}",
		month: "{{date, LL'.'y+useTZ}}",
		quarter: "{{date, q'.Quartal' y+useTZ}}",
		year: "{{date, y+useTZ}}",
	},
	btnClear: "Löschen",
	bool: {
		true: "Wahr",
		false: "Falsch",
	},
	reportTypes: {
		benchmark: "Benchmark",
		"data-set": "Datensatz",
		detail: "Detail",
	},
	keyboardShortcut: "Tastenkürzel: {{shortcut}}",
	generatedByAI: "Generiert durch KI",
	resultIdAllowedCharsHelper: "Erlaubte Zeichen: a-z, A-Z, 0-9, -, _",
	nps: {
		title: "Engagement Score",
		scoreTooltip: "Engagement Score: Prozent Promotoren - Prozent Detraktoren",
	},
	areas: {
		myArea: "Mein Bereich",
		administration: "Verwaltung",
		organization: "Organization",
	},

	learn_more: "Mehr erfahren",
	copy: "Kopieren",
	search: "Suchen...",
};
